import React from "react";
import { Route, Routes } from "react-router-dom";
import "./style.css";
import "./App.css";
import Projects from "./components/Projects/Projects";
import About from "./components/About/About";
import Home from "./components/Home/Home";
import NavBar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <div className="app-container">
      <div class="background">
        <div class="pattern-circle"></div>
        <div class="pattern-circle"></div>
        <div class="pattern-circle"></div>
        <div class="pattern-triangle"></div>
        <div class="pattern-triangle"></div>
        <div class="pattern-line"></div>
        <div class="pattern-line"></div>
        <div class="wave-lines">
          <div class="wave-line"></div>
          <div class="wave-line"></div>
          <div class="wave-line"></div>
          <div class="wave-line"></div>
        </div>
        <div class="pattern-circle"></div>
      </div>
      <div className="app-container-box">
        <NavBar />
        <ScrollToTop />
        <Routes>
          <Route path="/" exact element={<Home />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/about" element={<About />} />
        </Routes>
        <Footer />
        <div className="gap-bottom" />
      </div>
    </div>
  );
}

export default App;
